import { env } from '@ria-client/env';
import type { ValidationIssue } from '@ria-client/supergraph/utils/validation-utils';

export interface ComponentValidationErrorProps {
  props: {
    componentType: string;
    issues: ValidationIssue[];
  };
}

const NOISE_SEGMENTS = new Set(['props', 'children']);

export function ComponentValidationError({ props }: ComponentValidationErrorProps) {
  if (env.NEXT_PUBLIC_DEPLOYABLE_ENV === 'prod') {
    return null;
  }

  return (
    <div className="my-4 border border-destructive p-4">
      <p>
        Component Validation Failed: <strong>{props.componentType}</strong>
      </p>
      <p>This component could not be rendered because its data failed schema validation:</p>
      <ul>
        {props.issues.map((issue, index) => (
          <li className="font-mono typography-body-small" key={index}>
            {formatIssue(issue)}
          </li>
        ))}
      </ul>
      <p className="mt-4 text-muted-foreground">
        This warning is only visible in non-production environments.
      </p>
    </div>
  );
}

function simplifyPath(dotPath: string): string {
  return dotPath
    .split('.')
    .filter(s => !NOISE_SEGMENTS.has(s))
    .join(' > ');
}

function formatIssue(issue: ValidationIssue): string {
  let result = issue.message;
  if (issue.path) {
    result += ` at ${simplifyPath(issue.path)}`;
  }
  if (issue.expected) {
    result += ` (expected: ${issue.expected}, received: ${issue.received})`;
  }
  return result;
}
